import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  SelectChangeEvent,
} from "@mui/material";
import React, { FC } from "react";

interface Props {
  source?: string;
  setSource: (source: string) => void;
}

const Sources = [
  { label: "QR", value: "qr" },
  { label: "Embed", value: "embed" },
  { label: "Landing Page", value: "landing" },
];
export const SourceSelect: FC<Props> = ({ source = "", setSource }) => {
  const onUpdate = (e: SelectChangeEvent) => {
    const val = e.target.value;
    setSource(val);
    if (val) setSource(val);
  };

  return (
    <Box style={{ marginLeft: "20px" }}>
      <FormControl fullWidth>
        <Select
          id="demo-simple-select"
          onChange={onUpdate}
          size="small"
          displayEmpty
          value={source}
          sx={{ width: "140px" }}
        >
          <MenuItem key="" value="" selected>
            <Typography sx={{ opacity: 0.5 }}>Select Source</Typography>
          </MenuItem>
          {Sources.map(({ label, value }, i) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
